export default "__VITE_ASSET___K3Bbl3x__"